import React from 'react';
import { SistemaTipo } from "../../types/enum/enum";
import { Card, CardContent, Grid, IconButton, Stack, Typography } from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
import { useNavigate } from 'react-router-dom';
import { dateFormatter } from "../../utils/formatters";
import { CountryAvatar } from "../../components/icons/CountryAvatar";
import { rutaPorCodSistema } from "../sistema/RefactorLayout";

interface CardLimiteProps {
    fechaAprobacion?: Date;
    fechaVencimiento?: Date; // Nueva prop
    idMensaje?: number;
    codSistema?: SistemaTipo;
    codPais?: number;
    pais?: string;
}

function CardLimite({ fechaAprobacion, fechaVencimiento, idMensaje, codSistema, codPais, pais }: CardLimiteProps) {
    const navigate = useNavigate();

    return (
        <Card sx={{py:2, px:4}}>
                <Grid container spacing={2}>
                    {fechaVencimiento && (
                        <Grid item xs={12} sm={6} md={3}>
                            <Typography variant='body2' sx={{ mb: 2 }}>Fecha Vencimiento</Typography>
                            <Typography>{dateFormatter.toShortDate(fechaVencimiento)}</Typography>
                        </Grid>
                    )}

                    {fechaAprobacion && (
                        <Grid item xs={12} sm={6} md={3}>
                            <Typography variant='body2' sx={{ mb: 2 }}>Fecha Aprobación</Typography>
                            <Typography>{dateFormatter.toShortDate(fechaAprobacion)}</Typography>
                        </Grid>
                    )}

                    {idMensaje && codSistema && (
                        <Grid item xs={12} sm={6} md={3}>
                            <Typography variant='body2'>Operación</Typography>
                            <Stack direction={'row'} alignItems={'center'}>
                                <Typography># {idMensaje}</Typography>
                                <IconButton
                                    onClick={() => navigate(`/operacion/${rutaPorCodSistema[codSistema]}/${idMensaje}`)}>
                                    <LaunchIcon />
                                </IconButton>
                            </Stack>
                        </Grid>
                    )}

                    {pais && codPais && (
                        <Grid item xs={12} sm={6} md={3}>
                            <Typography variant='body2' sx={{ mb: 0 }}>País</Typography>
                            <Stack direction={'row'} alignItems={'center'} gap={1}>
                                <Typography>{pais}</Typography>
                                <CountryAvatar
                                    countryCode={codPais}
                                    sx={{ height: '40px', width: '40px', mt: 0.5 }}
                                />
                            </Stack>
                        </Grid>
                    )}
                </Grid>
        </Card>
    );
}

export default CardLimite;